const reducer = (state, action) => {
    switch (action.type) {
        case 'update':
            return { ...state, ...action.newState };
        default:
            return state;
    }
};

export default reducer;
